import type { ItemType } from "@/hooks/use-baseline";

interface TypeMeta {
  label: string;
  letter: string;
  description: string;
}

export const TYPES: Record<ItemType, TypeMeta> = {
  feature: {
    label: "Feature",
    letter: "F",
    description: "User-facing capability",
  },
  business: {
    label: "Business",
    letter: "B",
    description: "Business rule, policy, or workflow",
  },
  "tech-req": {
    label: "Tech requirement",
    letter: "TR",
    description: "Technical capability the system must provide",
  },
  "tech-cons": {
    label: "Tech constraint",
    letter: "TC",
    description: "Technical limit or boundary condition",
  },
  integration: {
    label: "Integration",
    letter: "I",
    description: "Connection to an external system or data source",
  },
  ui: {
    label: "UI",
    letter: "UI",
    description: "Visual or interaction design detail",
  },
  copy: {
    label: "Copy",
    letter: "C",
    description: "Specific text content or wording",
  },
  process: {
    label: "Process",
    letter: "P",
    description: "Operational procedure or workflow",
  },
  nfr: {
    label: "NFR",
    letter: "N",
    description: "Non-functional requirement (perf, security, etc.)",
  },
  implied: {
    label: "Implied",
    letter: "IM",
    description: "Assumed but not stated explicitly",
  },
  passing: {
    label: "Passing mention",
    letter: "—",
    description: "Mentioned in conversation, not a requirement",
  },
};

export const TYPE_ORDER: ReadonlyArray<ItemType> = [
  "feature",
  "business",
  "tech-req",
  "tech-cons",
  "integration",
  "ui",
  "copy",
  "process",
  "nfr",
  "implied",
  "passing",
];
